import { tabsAnatomy } from '@chakra-ui/anatomy';

const chakraTabsParts = tabsAnatomy.keys;

const customTabsParts = ['number'] as const;

type ChakraTabsPart = (typeof chakraTabsParts)[number];

type CustomTabsPart = (typeof customTabsParts)[number];

type TabsPart = ChakraTabsPart | CustomTabsPart;

export const TABS_PARTS: readonly TabsPart[] = [
  ...chakraTabsParts,
  ...customTabsParts,
] as const;
